export default __webpack_public_path__ + "static/media/SG FR upd 1.5ed4c374.jpeg";